module.exports = __webpack_public_path__ + "img/arrow-bottom-black.22de7f6.svg";